import axios from 'axios';

import { AdvancedError } from './AdvancedError';
import { ForbiddenErrorPage } from './ForbiddenErrorPage';
import { ResourceNotFoundErrorPage } from './ResourceNotFoundErrorPage';

interface ErrorDistributorProps {
    error?: unknown;
    stack?: string;
    resetError?: () => void;
}

export const ErrorDistributor = ({ error, stack, resetError }: ErrorDistributorProps) => {
    if (axios.isAxiosError(error)) {
        if (error.response?.status === 404) {
            return <ResourceNotFoundErrorPage />;
        }
        if (error.response?.status === 403) {
            return <ForbiddenErrorPage />;
        }
    }

    return <AdvancedError error={error} stack={stack} resetError={resetError} />;
};
